import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";

import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type { APIResponse, DefaultMatterExpense } from "@/lib/types";

export const createMatterDefaultExpenseV1 = (data: {
  defaultMatterExpense: Pick<
    DefaultMatterExpense,
    "label" | "cost" | "category" | "incidentTypeIds"
  > &
    Partial<DefaultMatterExpense>;
}) => {
  const { defaultMatterExpense } = data;
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<DefaultMatterExpense>
    >(`${baseFastApiMatterRoute}/default-expenses`, defaultMatterExpense)
    .then((res) => res.data);
};

export const updateMatterDefaultExpenseV1 = (
  defaultMatterExpense: Pick<DefaultMatterExpense, "id" | "dateModified"> &
    Partial<DefaultMatterExpense>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<DefaultMatterExpense>
    >(`${baseFastApiMatterRoute}/default-expenses`, defaultMatterExpense)
    .then((res) => res.data);
};

export const deleteMatterDefaultExpenseV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<DefaultMatterExpense>
    >(`${baseFastApiMatterRoute}/default-expenses/${id}`)
    .then((res) => res.data);
};
